<!--
@Create By Tim For 19/08/21
@在线资料库列表组件
-->
<template>
  <div class="DataList">
    <div class="title">
      <el-breadcrumb separator-class="el-icon-arrow-right"><el-breadcrumb-item>课程资料库</el-breadcrumb-item></el-breadcrumb>
    </div>

    <!-- 批量下载 -->
    <div class="batchDownLoad">
      <span></span>
      文档
      <el-button class="downloadBtn" type="primary" plain size="small" @click="batchDownloads">批量下载</el-button>
    </div>

    <!-- 资料库表格 -->
    <el-table :header-cell-style="{ background: '#F6F6F9' }" :data="tableData" stripe border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>

      <el-table-column prop="name" label="文档名称">
        <template slot-scope="props">
          <a @click="goToInfo(props.row)" href="javascript:;">{{ props.row.docName }}</a>
        </template>
      </el-table-column>

      <el-table-column prop="downloadCount" label="下载量" width="80">
        <template slot-scope="props">
          {{ props.row.docDownloadVolume + '次' }}
        </template>
      </el-table-column>

      <el-table-column prop="downloadTime" label="下载时间" width="180">
        <template slot-scope="props">
          {{ props.row.updateTime }}
        </template>
      </el-table-column>
    </el-table>

    <!-- 课程分页组件 -->
    <div class="pagination" v-if="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totals"
        @current-change="currentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Bus from '../../bus';
import api from '../../../config/api';
import { getToken } from 'chaos-sso-util';

export default {
  name: 'DataList',
  data() {
    return {
      // 资料名， 用于搜索
      dataName: '',
      // 资料库数据集合
      tableData: [],
      // 是否显示分页
      pagination: true,
      // 课程列表集合
      courseData: [],
      // 当前页
      currentPage: 1,
      // 每页显示几条
      pageSize: 24,
      // 数据总条数
      totals: 0,
      // 选中个数
      multipleSelection: []
    };
  },

  created() {
    Bus.$on('searchDoc', data => {
      this.dataName = data;
      this.getData();
    });
  },

  mounted() {
    this.dataName = this.$route.query.docName;
    this.getData();
  },

  methods: {
    // 表格多选
    handleSelectionChange(val) {
      // 将拿到的所有的资料ID转换成字符串
      if (val && val.length > 0) {
        let arr = [];
        let docNames = [];
        for (var i = 0; i < val.length; i++) {
          arr.push(val[i].id);
          docNames.push(val[i].docName);
        }
        this.multipleSelection = arr.join();
        this.docNameSelection = docNames.join();
      } else {
        this.multipleSelection = [];
        this.docNameSelection = [];
      }
    },

    // 点击页码
    currentChange(val) {
      this.currentPage = val;
      this.getData();
    },

    // 点击上一页
    prevClick(val) {
      this.getData();
    },

    // 点击下一页
    nextClick(val) {
      this.getData();
    },

    // 跳转文档详情页
    goToInfo(row) {
      this.$router.push({ path: '/DataInfo/' + row.id });
    },

    // 获取文档列表数据
    getData() {
      if (!this.dataName) {
        this.dataName = '';
      }
      this.$axios.get(api + 'portal/doc/list?docName=' + this.dataName + '&pageNum=' + this.currentPage + '&pageSize=24').then(res => {
        if (res && res.rows) {
          this.pagination = true;
          this.tableData = res.rows;
          this.totals = res.total;
        } else {
          this.pagination = false;
          this.tableData = [];
        }
      });
    },

    createObjectURL(object) {
      return window.URL ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object);
    },

    // 批量下载方法
    batchDownloads() {
      if (this.multipleSelection.length < 1) {
        this.$message.error('至少勾选一项！');
        return;
      }
      var self = this;
      var xhr = new XMLHttpRequest();
      var formData = new FormData();
      xhr.open('get', api + 'portal/doc/download?id=' + this.multipleSelection); //url填写后台的接口地址，如果是post，在formData append参数（参考原文地址）
      xhr.setRequestHeader(process.env.VUE_APP_SSO_HEADER_TOKEN, getToken());
      xhr.responseType = 'blob';
      xhr.onload = function(e) {
        if (this.status == 200) {
          var blob = this.response;
          var filename = self.docNameSelection;
          if (self.multipleSelection.indexOf(',') != -1) {
            filename = '批量下载.zip';
          }
          // console.log(this.response)
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, filename);
          } else {
            var a = document.createElement('a');
            var url = self.createObjectURL(blob);
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(formData);
    }
  }
};
</script>

<style scoped>
.DataList {
  width: 1440px;
  min-height: 500px;
  margin: 0 auto;
  overflow: hidden;
  overflow-y: auto;
}

.DataList .title {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #000;
  width: 1440px;
  margin: 0 auto;
}

.DataList .batchDownLoad {
  padding: 15px 0;
  font-size: 16px;
  color: #1d1e28;
  overflow: hidden;
  border-top: 1px solid #d3d3d3;
}

.DataList .batchDownLoad span {
  width: 5px;
  height: 20px;
  background-color: #00b4e0;
  display: inline-block;
  vertical-align: sub;
  margin-right: 5px;
}

.DataList .batchDownLoad .downloadBtn {
  float: right;
}

.DataList .pagination {
  margin: 20px 0;
  text-align: center;
}

.DataList a {
  font-size: 14px;
  color: #136dd7;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/DataList/DataList.vue